import { Reveal, Overline } from "./motion";
import { useLang } from "../../i18n";

export const Record = () => {
  const { c } = useLang();
  return (
    <section id="record" data-testid="record-section" className="py-24 md:py-36 bg-[var(--bg-primary)]">
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-20">
        <Reveal>
          <Overline>{c.record.overline}</Overline>
          <h2 className="font-serif text-4xl md:text-6xl tracking-tight mt-5 leading-[0.95] max-w-3xl">
            {c.record.heading}
          </h2>
        </Reveal>

        <div className="mt-16">
          {c.record.items.map((e, i) => (
            <Reveal key={i} delay={i * 0.04}>
              <div
                data-testid={`experience-${i}`}
                className="group grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-8 items-baseline py-8 border-t border-[var(--border)] last:border-b hover:bg-[var(--bg-secondary)] transition-colors duration-300 px-2 md:px-4"
              >
                <span className="md:col-span-2 font-mono text-xs uppercase tracking-[0.15em] text-[var(--accent)]">{e.period}</span>
                <h3 className="md:col-span-3 font-serif text-2xl text-[var(--text-primary)]">{e.role}</h3>
                <span className="md:col-span-3 font-sans text-base text-[var(--text-primary)]">{e.org}</span>
                <p className="md:col-span-4 font-sans text-sm text-[var(--text-secondary)] leading-relaxed">{e.note}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
